import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, useIsForman } from '../../helpers/hooks';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const isForman = useIsForman();
  const location = useLocation();

  // Not authenticated -> login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Forman users -> redirect to forman dashboard
  if (isForman) {
    return <Navigate to="/forman" replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
